import styled from 'styled-components';

export const StyledListingSearch = styled.div`
  display: grid;
  grid-template-columns: 260px 260px 260px 270px 110px;
  grid-template-rows: 78px;
  grid-gap: 0 20px;
  margin: 0 0 0 0;
`;

export const SearchBarWrapper = styled.div`
  max-width: fit-content;
  & > div {
    max-width: 1240px;
    width: 1240px;
  }
`;

export const StyledListingSearchContainer = styled.div`
  display: grid;
  grid-template-columns: 400px 400px 120px;
  grid-template-rows: auto auto;
  column-gap: 20px;
  row-gap: 10px;
`;
